<div class="dialog-wrapper content-creation">
  <h2 *ngIf="isNewBanner" mat-dialog-title>
    {{ "brand.campaign.banner.createBanner" | translate }}
  </h2>
  <h2 *ngIf="!isNewBanner" mat-dialog-title>
    {{ "brand.campaign.banner.editBanner" | translate }}
  </h2>
  <mat-dialog-content>
    <form>
      <section class="upload-image">
        <h3>
          {{ "brand.campaign.banner.bannerImages" | translate }}
          <app-tooltip
            text="{{ 'brand.campaign.banner.bannerImagesToolTip' | translate }}"
          ></app-tooltip>
        </h3>
        <ul class="slider-list">
          <ng-container *ngIf="!saving && uploadFiles.length">
            <li *ngFor="let file of uploadFiles" class="slider-item">
              <div class="slider-item-button">
                <img class="slider-item-img" [src]="file.displayUrl" />
              </div>
              <span class="slider-item-details">
                <button class="remove" (click)="deleteFileConfirm(file)">
                  <mat-icon>delete</mat-icon>
                </button>
              </span>
            </li>
          </ng-container>

          <li *ngFor="let file of banner.files" class="slider-item">
            <div class="slider-item-button">
              <img class="slider-item-img" [src]="file.file" />
            </div>
            <span class="slider-item-details">
              <button class="remove" (click)="deleteFileConfirm(file)">
                <mat-icon *ngIf="!deletingFileId || deletingFileId !== file.id"
                  >delete</mat-icon
                >
                <mat-spinner
                  *ngIf="deletingFileId === file.id"
                  [diameter]="25"
                ></mat-spinner>
              </button>
            </span>
          </li>
        </ul>
        <app-file-uploader
          [uploaderTitle]="'brand.campaign.banner.dragAndDropTitle' | translate"
          [uploaderSubtitle]="uploaderSubtitle"
          [uploadUrl]="uploaderUrl"
          [uploadData]="uploadData"
          [fieldName]="uploaderFieldName"
          [autoUpload]="false"
          [responseMapper]="fileUploaderResponseMapper"
          (fileAddedToQueue)="onAfterAddingFile($event)"
          (apiResponse)="handleUploadResponse($event)"
          (uploadError)="fileUploaderErrorHandler($event)"
        />
      </section>

      <section class="suggested-text">
        <h3>
          {{ "brand.campaign.banner.title" | translate }}
          <app-tooltip
            text="{{ 'brand.campaign.banner.titleToolTip' | translate }}"
          ></app-tooltip>
        </h3>
        <div>
          <mat-form-field class="post-content">
            <mat-label>{{
              "brand.campaign.banner.titlePlaceholder" | translate
            }}</mat-label>
            <input
              matInput
              #username="ngModel"
              [(ngModel)]="banner.title"
              id="post-content"
              name="post-content"
              type="text"
              tabindex="-1"
              required
            />
            <mat-error
              class="email-error"
              *ngIf="username.errors && username.errors['required']"
            >
              {{ "brand.campaign.banner.titleRequired" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </section>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button class="btn btn--transparent" tabindex="-1" [mat-dialog-close]="">
      {{ "shared.cancel" | translate }}
    </button>
    <button
      class="btn btn--primary"
      tabindex="-1"
      (click)="saveContent()"
      [disabled]="
        saving || !banner.title || (isNewBanner && uploadFiles.length === 0)
      "
    >
      <span *ngIf="saving">{{ "shared.saving" | translate }}</span>
      <span *ngIf="!saving">{{
        "brand.campaign.banner.saveButton" | translate
      }}</span>
    </button>
  </mat-dialog-actions>
</div>
